module.exports = __webpack_public_path__ + "static/media/message-mediation.22f4f0a9.svg";